import { Action } from 'redux'
import { INITIAL_STATE, TServiceTrackerReducer } from './TYPES'

export default function ServiceTrackerReducer(
  state: TServiceTrackerReducer = INITIAL_STATE,
  action: Action<string>
): TServiceTrackerReducer {
  const { type } = action
  const typeParts = type.split('/')
  const endingPart = typeParts.pop()

  switch (endingPart) {
    case 'LOADING': {
      const key = typeParts.join('/')
      return { ...state, [key]: 'LOADING' }
    }
    case 'SUCCESS': {
      const key = typeParts.join('/')
      return { ...state, [key]: 'SUCCESS' }
    }
    case 'ERROR': {
      const key = typeParts.join('/')
      return { ...state, [key]: 'ERROR' }
    }
    default: {
      return state
    }
  }
}
